import { createClient } from "@supabase/supabase-js"

const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL || ""
const supabaseAnonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY || ""

const effectiveUrl = supabaseUrl || "https://placeholder.supabase.co"
const effectiveKey = supabaseAnonKey || "placeholder-key"

export const supabase = createClient(effectiveUrl, effectiveKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: {
      getItem: (key) => { try { return localStorage.getItem(key); } catch { return null; } },
      setItem: (key, value) => { try { localStorage.setItem(key, value); } catch { /* ignore */ } },
      removeItem: (key) => { try { localStorage.removeItem(key); } catch { /* ignore */ } },
    },
  },
})

export const isConfigured = !!(supabaseUrl && supabaseAnonKey)
